import { render } from "./CompanyLedger.vue?vue&type=template&id=c24a0f64"
import script from "./CompanyLedger.vue?vue&type=script&lang=js"
export * from "./CompanyLedger.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__